import React from "react";
import { useTranslation } from "react-i18next";
import { MegaphoneIcon } from "@heroicons/react/24/outline";
import CustomTitleTerms from "../termsAndConditions/customTitleTerms";
import CustomTermPoints from "../termsAndConditions/customTermPoints";
import CustomTextingCard from "../termsAndConditions/customCard";

const QualityControlAndShipmentPhotography = () => {
  const { t, i18n } = useTranslation();

  const isRTL = i18n.language === "ar";

  return (
    <div
      className={`px-4 py-3 lg:px-0 lg:py-8 max-container ${
        isRTL ? "rtl" : "ltr"
      }`} // Set direction
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div
        className={` ${
          isRTL ? "text-right" : "text-left"
        }  lg:mx-0  py-6 lg:py-10  flex flex-col gap-y-2`}
      >
        {/* Quality Inspection Service */}
        <CustomTitleTerms title={t("qualityCheckTitle")} first={true} />

        {/* Quality Points */}
        {t("qualityPoints", { returnObjects: true }).map((point, index) => (
          <CustomTermPoints key={index} title={point} />
        ))}

        {/* Announcement */}
        <CustomTextingCard
          Icon={MegaphoneIcon}
          title={t("announcement")}
          subTitle={t("announcementDetails")}
        />
      </div>
    </div>
  );
};

export default QualityControlAndShipmentPhotography;
